import { BitbucketIcon, CompassIcon, ConfluenceIcon, JiraIcon, JiraProductDiscoveryIcon, JiraServiceManagementIcon, LoomIcon, StatuspageIcon, TrelloIcon } from '@atlaskit/logo';
import { AtlassianAppTargets } from './types';
export const TRELLO_SIGNUP_URL = 'https://trello.com/signup';
export const BITBUCKET_SIGNUP_URL = 'https://bitbucket.org';
export const ATLASSIAN_APP_LIST = [{
  productName: 'Jira',
  description: 'Flexible planning for every team',
  brandIcon: JiraIcon,
  targetProduct: AtlassianAppTargets.JIRA_SOFTWARE
}, {
  productName: 'Confluence',
  description: 'Create and collaborate on docs',
  brandIcon: ConfluenceIcon,
  targetProduct: AtlassianAppTargets.CONFLUENCE
}, {
  productName: 'Loom',
  description: 'Automate meeting notes',
  brandIcon: LoomIcon,
  targetProduct: AtlassianAppTargets.LOOM
}, {
  productName: 'Jira Product Discovery',
  description: 'Prioritize ideas and build roadmaps',
  brandIcon: JiraProductDiscoveryIcon,
  targetProduct: AtlassianAppTargets.JIRA_PRODUCT_DISCOVERY
}, {
  productName: 'Jira Service Management',
  description: 'Organize and triage requests',
  brandIcon: JiraServiceManagementIcon,
  targetProduct: AtlassianAppTargets.JIRA_SERVICE_DESK
}, {
  productName: 'Statuspage',
  description: 'Share live system status',
  brandIcon: StatuspageIcon,
  targetProduct: AtlassianAppTargets.STATUSPAGE
}, {
  productName: 'Compass',
  description: 'Catalog services and systems',
  brandIcon: CompassIcon,
  targetProduct: AtlassianAppTargets.COMPASS
}, {
  productName: 'Bitbucket',
  description: 'Collaborate on code',
  brandIcon: BitbucketIcon,
  targetProduct: AtlassianAppTargets.BITBUCKET
}, {
  productName: 'Trello',
  description: 'Visualize tasks on a board',
  brandIcon: TrelloIcon,
  targetProduct: AtlassianAppTargets.TRELLO
}];